module.exports = __webpack_public_path__ + "cv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/cv.svg
// module id = 506
// module chunks = 0